"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getClassNameForMenuItem;

var _classnames = _interopRequireDefault(require("classnames"));

var _each = _interopRequireDefault(require("lodash/each"));

function getClassNameForMenuItem(className, menuItem) {
  var classObj = {};

  if (menuItem.accountTypes) {
    classObj.at = true;
    (0, _each["default"])(menuItem.accountTypes, function (accountType) {
      classObj['at-' + accountType] = true;
    });
  }

  if (menuItem.feature) {
    classObj.ft = true;
    classObj['ft-' + menuItem.feature] = true;
  }

  return (0, _classnames["default"])(className, classObj);
}